import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql } from "react-apollo";
import { queryGetChannels } from "Apollo";
import Picker from "module-common/Picker";

export default graphql(queryGetChannels)(
  class PickerChannel extends Component {
    static propTypes = { onSelected: PropTypes.func };

    render() {
      const channels = this.props.data.getCompanyChannelHandler;
      const options = [];
      if (channels) {
        for (const channel of channels) {
          options.push({
            label: `@${channel.name} (${channel.channel.name})`,
            value: channel
          });
        }
        options.push({
          label: `All Channels`,
          value: null
        });
      }
      return (
        <Picker {...this.props} options={options}>
          {this.props.children}
        </Picker>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/module-common/PickerChannelWithQuery.js